// extracted by mini-css-extract-plugin
export default {"zoomModal":"hfa-z","image":"ifa-z","button":"jfa-z","isOverlayShown":"kfa-z"};